import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';
import { useActionDispatcher } from '../../hooks';
import VideoMenuForm from './VideoMenuForm';
import {
  createVideoMenuRequest,
  initVideoMenuRequest,
  resetCurrentVideoMenu,
} from '../../store/modules/video-menus/actions';
import {
  isVideoMenuPersistent,
  selectVideoMenu,
} from '../../store/modules/video-menus/selectors';

const VideoMenuCreate = () => {
  const dispatch = useDispatch();
  const createVideoMenu = useActionDispatcher(createVideoMenuRequest);
  const persistent = useSelector(isVideoMenuPersistent);
  const videoMenu = useSelector(selectVideoMenu);

  useEffect(() => {
    dispatch(initVideoMenuRequest());
    return () => {
      dispatch(resetCurrentVideoMenu());
    };
  }, [dispatch]);

  useEffect(() => {
    if (persistent) {
      dispatch(replace(`/dashboard/admin/video-menus/${videoMenu.data!.id}`));
    }
  }, [persistent, videoMenu.data, dispatch]);

  return (
    <VideoMenuForm
      creatingMode
      record={videoMenu}
      onSubmit={createVideoMenu}
    />
  );
};

export default VideoMenuCreate;
